import { http } from '../../../../api/http';
import type { StockItem, StockAlert } from '../types/stock.types';

export const stockService = {
  async getAll(idDeposito?: number, idSucursal?: number): Promise<StockItem[]> {
    const params = new URLSearchParams();
    if (idDeposito) params.append('idDeposito', idDeposito.toString());
    if (idSucursal) params.append('idSucursal', idSucursal.toString());
    const response = await http.get(`/stock?${params.toString()}`);
    return response.data;
  },

  async getByArticulo(idArticulo: number): Promise<StockItem[]> {
    const response = await http.get(`/stock/articulo/${idArticulo}`);
    return response.data;
  },

  async search(term: string): Promise<StockItem[]> {
    const response = await http.get(`/stock/search?term=${encodeURIComponent(term)}`);
    return response.data;
  },

  async getAlerts(idDeposito?: number): Promise<StockAlert[]> {
    const params = idDeposito ? `?idDeposito=${idDeposito}` : '';
    const response = await http.get(`/stock/alerts${params}`);
    return response.data;
  },
};
